import React from 'react';
import './style.css';

export default function Index() {
  return (
    <div className="container-error">
        <img src="500-error.jpeg" alt="" className="error-500" />
    </div>
  )
}
